'use client'

import { useEffect } from 'react'
import { useBlogCategory } from '@/context/BlogCategoryContext'

export default function BlogPostClientShell({ categorySlug, children }) {
  const { setBlogCategory } = useBlogCategory()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (categorySlug) {
      setBlogCategory(categorySlug)
    }
    return () => setBlogCategory(null)
  }, [categorySlug, setBlogCategory])

  return children
}
